import Icon from "@mui/material/Icon";

const iconMap: Record<string, string> = {
  Account: "account_circle",
  Menu: "menu",
  More: "more_vert",
  Notifications: "notifications",
  Refresh: "refresh",
  Save: "save",
  Search: "search",
  Settings: "settings",
  Action: "flash_on",
  Add: "add",
  Edit: "edit",
  Remove: "remove",
  Download: "get_app",
  Upload: "publish",
  Print: "print",
  Design: "settings",
  Tag: "local_offer",
  Calendar: "calendar_month",
  Agenda: "view_agenda",
  Sms: "sms",
  Email: "email",
  Call: "phone",
  ComposeSMS: "perm_phone_msg",
  Contact: "contact_page",
  CalendarEvent: "event",
  Money: "attach_money",
  Campaign: "campaign",
  Delete: "delete",
  Cancel: "cancel",
  MyLocation: "my_location",
  Place: "place",
  Expand: "expand",
  Task: "task",
  Reminder: "watch_later",
  Map: "south_america",
  Card: "view_agenda",
  Grid: "view_list",
  View: "wysiwyg",
};

export function NamedIcon({ icon }: { icon?: string }) {
  if (!icon) return null;

  // for now assumes 24px for some reason :(
  if (icon.startsWith("/icons") || icon.startsWith("https://"))
    return <img src={icon} width={24} alt={icon} />;

  const glyph = iconMap[icon] ?? icon;
  if (glyph) return <Icon sx={{ fontSize: 24 }}>{glyph}</Icon>;

  return null;
}
